import {Component, OnInit} from '@angular/core';
import {AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
    standalone: false,
    selector: 'core-block-benefits-new',
    templateUrl: './block-benefits-new.component.html',
})

export class BlockBenefitsNewComponent extends BlockAbstractComponent implements OnInit {
    isDrawDisabled!: boolean;

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        private observer: BreakpointObserver
    ) {
        super(
            parser,
            auth
        );
    }

    ngAfterViewInit() {
        this.observer.observe('(min-width: 768px)').subscribe(data => {
            this.isDrawDisabled = data.matches;
        });
    }

}
